export const i18nNamespace = 'dreamup';
export const enum DreamupFormModals {
  POINTS = 'points',
  PROMPT_GUIDELINES = 'prompt_guidelines',
}
